import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createTask } from '../../store/slices/taskSlice';
import { TASK_STATUS, TASK_PRIORITY } from '../../utils/constants';

const TaskModal = ({ projectId, projectMembers, onClose, onSuccess }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    assigned_to: [],
    status: TASK_STATUS.TODO,
    priority: TASK_PRIORITY.MEDIUM,
    due_date: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'assigned_to') {
      const options = Array.from(e.target.selectedOptions, (option) => option.value);
      setFormData({ ...formData, assigned_to: options });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const submitData = {
        ...formData,
        project: projectId,
        due_date: formData.due_date || null
      };
      const result = await dispatch(createTask(submitData)).unwrap();
      onSuccess(result);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal fade show" style={{ display: 'block' }} tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create New Task</h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                {error && <div className="alert alert-danger">{error}</div>}

                <div className="mb-3">
                  <label className="form-label">Task Title *</label>
                  <input
                    type="text"
                    name="title"
                    className="form-control"
                    value={formData.title}
                    onChange={handleChange}
                    placeholder="e.g., Design landing page mockups"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    name="description"
                    className="form-control"
                    rows={3}
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Task details..."
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Assign To (Hold Ctrl/Cmd to select multiple)</label>
                  <select
                    name="assigned_to"
                    className="form-select"
                    value={formData.assigned_to}
                    onChange={handleChange}
                    multiple
                    style={{ minHeight: '120px' }}
                    disabled={!projectMembers || projectMembers.length === 0}
                  >
                    {(projectMembers || []).map((member) => (
                      <option key={member._id} value={member._id}>
                        {member.name} ({member.employee_code})
                      </option>
                    ))}
                  </select>
                  {(!projectMembers || projectMembers.length === 0) ? (
                    <small className="text-muted d-block mt-1">
                      This project has no members yet. Ask an admin to add members before assigning tasks.
                    </small>
                  ) : (
                    <small className="text-muted d-block mt-1">
                      Assigned members will receive an email notification.
                    </small>
                  )}
                </div>

                <div className="row g-3">
                  <div className="col-sm-6">
                    <label className="form-label">Priority</label>
                    <select
                      name="priority"
                      className="form-select"
                      value={formData.priority}
                      onChange={handleChange}
                    >
                      {Object.values(TASK_PRIORITY).map((priority) => (
                        <option key={priority} value={priority}>
                          {priority}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">Due Date</label>
                    <input
                      type="date"
                      name="due_date"
                      className="form-control"
                      value={formData.due_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Creating...' : 'Create Task'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default TaskModal;
